import { RootEpic } from 'typesafe-actions';

import { createPaginatedGetEpic } from '../utils';
import { getActiveAccountDelegationsAsync } from './actions';

export const loadActiveDelegations: RootEpic = (
  action$,
  state$,
  { getPaginatedAccountDelegationsSubscription }
) =>
  createPaginatedGetEpic(
    action$,
    getActiveAccountDelegationsAsync,
    getPaginatedAccountDelegationsSubscription
  );
